module.exports = __webpack_public_path__ + "media/icons/ubezpieczenia-baner@3x-5b3de95d.svg";